
import KpBottomBtn from '@/plugin/bottombtn'
import { registCorp } from '@/controller/corp'
import { getCountryList, getAllAddress, exchange, getIndustry2, exchange2} from '@/controller/basic'
import Position from '@/plugin/Position'
import KpFileUpload from '@/plugin/KpFileUpload'
import industryChecker from '@/plugin/industry-checker'

import XInput from 'vux/src/components/x-input/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Toast from 'vux/src/components/toast/index.vue'


const mailreg = /.+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
export default {
name: 'addcustomer',
components: {
XInput,
XAddress,
Group,
XHeader,
Cell,
Datetime,
PopupPicker,
KpBottomBtn,
TransferDom,
Actionsheet,
Picker,
Divider,
Toast,
industryChecker,
Position,
KpFileUpload
},
data() {
return {
corp_name: '',
name: '',
account: sessionStorage.accountPhone || sessionStorage.accountEmail,
address: '',
locationList: [],
location: [],
perchase_in_charge: '',
loading: false,
country: [],
countryList: [],
showSuccessToast: false,
showErrorToast: false,
errorRequestId: '',
showMoreLocation: true,
positionModel: false,
isEdit: true,
files: [],
industrySubVisible: false,
industryList: [],
mainIndustry: [],
subIndustry: []
}
},
created() {
this.country = ['17230']
getCountryList({
callback: response => {
if (response.code === 0 && response.data.length) {
let country = response.data
let list = []
for (let {
countryId,
countryName
} of country) {
list.push({
name: countryName,
value: countryId,
parent: '0'
})
}
this.countryList = list
}
}
})
getAllAddress({
callback: response => {
if (response.code === 0) {
let allAddress = response.data
let location = []
if (allAddress.provinces.length) {
for (let { provinceId, provinceName } of allAddress.provinces) {
location.push({
name: provinceName,
value: provinceId,
parent: 0
})
}
}
if (allAddress.citys.length) {
for (let { provinceId, cityName, cityId } of allAddress.citys) {
location.push({
name: cityName,
value: cityId,
parent: provinceId
})
}
}
if (allAddress.districts.length) {
for (let { districtId, districtName, cityId } of allAddress.districts) {
location.push({
name: districtName,
value: districtId,
parent: cityId
})
}
}
this.locationList = location

}
}
})
},
watch: {
country (val) {
if (val[0] !== '17230') {
this.showMoreLocation = false
} else {
this.showMoreLocation = true
}
}
},
methods: {
getWxAddress() {
wx.openAddress({
success: (res) => {

let temp = JSON.parse(JSON.stringify(this.country))
temp[0] = '17230'
this.country = temp

exchange({
cityName: res.cityName,
countyName: res.countryName,
provinceName: res.provinceName,
callback: response => {
let temp1 = JSON.parse(JSON.stringify(this.location))
temp1[0] = response.data.provinceId
temp1[1] = response.data.cityId
temp1[2] = response.data.districtId
this.location = temp1
this.address = res.detailInfo
}
})
},
cancel: () => {
}})
},
onCountryChange () {
if (this.country[0] !== '17230') {
this.location[0] = 0
this.location[1] = 0
this.location[2] = 0
}
},
register () {
let { corp_name, name, address, account, location, country } = this
let phone = ''
let email = ''
if (account.includes('@')) {
email = account
} else {
phone = account
}
let storeImages = ''
let imgSrcArr = []
if (this.files.length > 0 ) {
this.files.forEach(item => {
imgSrcArr.push(item.src)
})
} else {
this.$vux.alert.show({
content: '请上传门店图片'
})
return
}
storeImages = imgSrcArr.join(',')
if (!this.loading) {
let request = {
storeImages,
countryId: country[0],
provinceId: location[0],
cityId: location[1],
districtId: location[2],
corpAddress: address,
corpAdminName: name,
corpName: corp_name,
email,
phone,
corpType: localStorage.agentType == 2 ? 3 : 1,
mainIndustryId: localStorage.mainIndustryId,
corpVersion1: localStorage.corpVersion1,
corpPlugin: localStorage.corpPlugin
}
if (this.subIndustry.length > 0) {
this.subIndustry.forEach((item, index) => {
request['secondIndustryId' + (index + 1)] = this.subIndustry[index].id
})
}
if (localStorage.clueId && localStorage.clueId != 'undefined') {
request.clueId = localStorage.clueId
} else {
this.$vux.toast.show({
text: '本次注册没有线索ID:' + localStorage.clueId,
type: 'cancel',
width: '180px'
})
return
}

this.loading = true
registCorp({...request,
callback: response => {
this.loading = false
this.showSuccessToast = true
this.showErrorToast = false
if (response.code === 0) {

this.$router.push('/downLoad')
}
},
errorback: error => {
this.loading = false
this.showSuccessToast = false
}
})
}
},
checkForm() {
let { corp_name, name, address, account, location } = this
if (!corp_name || corp_name.length > 40) {
this.$vux.toast.show({
text: '企业名为空或超出40个字',
type: 'cancel',
width: '140px'
})
return
}
if (name.length < 2 || name.length > 20) {
this.$vux.toast.show({
text: '联系人长度应为2-20个字',
type: 'cancel',
width: '200px'
})
return
}
if (!account) {
this.$vux.toast.show({
text: '账号不能为空',
type: 'cancel',
width: '200px'
})
return
} else {
account = account.replace(/\s/g, '')
if (!(/\d$/.test(account))) {
if (account.length > 40 || !mailreg.test(account)) {
this.$vux.toast.show({
text: '邮箱填写错误',
type: 'cancel',
width: '200px'
})
return
}
} else {
if (!(/^1\d{10}$/.test(account))) {
this.$vux.toast.show({
text: '手机号码格式填写错误' + account,
type: 'cancel',
width: '200px'
})
return
}
}
}
if (location.length === 0) {
this.$vux.toast.show({
text: '请选择地区范围',
type: 'cancel',
width: '200px'
})
return
}
if (!address || address.length > 200) {
this.$vux.toast.show({
text: '请输入200字以内的详细地址',
type: 'cancel',
width: '200px'
})
return
}
this.register()
},
updateSuccess (files, obj) {
console.log(files, obj)
this.files = files
},
openIndustrySub () {
console.log('open!')
this.industrySubVisible = true
},
closeIndustrySub () {
this.industrySubVisible = false
},
industrySubOk (data) {
console.log('industry sub ok!', data)
this.subIndustry = data
this.industrySubVisible = false
},
getIndustryList () {
getIndustry2().then(res => {
this.industryList = res.data
})
},
locationFn (loc) {
const params = {
cityName: loc.cityname,
address: loc.poiaddress
}
this.exchange(params, (res) => {
if (res && res.provinceId && res.cityId && res.districtId) {
this.location = [res.provinceId, res.cityId, res.districtId]
this.address = this.getAddress(loc.poiaddress)
}
})
this.positionModel = false
},
getAddress (poiaddress) {
let mak = ['区', '县']
if (poiaddress) {
if (poiaddress.indexOf(mak[0]) > -1 && poiaddress.indexOf(mak[1]) > -1) {
return poiaddress.substring(poiaddress.indexOf(mak[0]) + 1)
} else if (poiaddress.indexOf(mak[0]) > -1) {
return poiaddress.substring(poiaddress.indexOf(mak[0]) + 1)
} else if (poiaddress.indexOf(mak[1]) > -1) {
return poiaddress.substring(poiaddress.indexOf(mak[1]) + 1)
} else {
return poiaddress
}
} else {
return ''
}
},
exchange (params, callback) {
this.$vux.loading.show({text: ''})
const request = Object.assign(params, {
callback: res => {
callback && callback(res.data)
this.$vux.loading.hide()
},
errorback: error => {
this.$vux.loading.hide()
}
})
exchange2(request)
}
}
}




// WEBPACK FOOTER //
// ./src/components/register.vue